import { Injectable } from '@angular/core';
import { IResponseObjectSuccess } from '@core/interfaces/response-success';
import { PaymentResponseData, PaymentResult } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class MerchantMXHelper {
  private responseCodes: {
    [key: string]: { message: string; action?: string };
  } = {
    // Códigos de éxito                                                                                                                                                          
    '00': { message: 'Payment approved', action: 'none' },
    '0': { message: 'Payment approved', action: 'none' },

    // Common rejection codes
    '01': { message: 'Contact the issuing bank', action: 'contact_bank' },
    '02': { message: 'Transaction not allowed', action: 'contact_bank' },
    '04': { message: 'Card retained for possible fraud', action: 'fraud_alert'},
    '05': { message: 'Transaction declined', action: 'retry_or_new_card' },
    '14': { message: 'Invalid card number', action: 'check_card' },
    '30': { message: 'Cardnumber is invalid, please try again' },
    '51': { message: 'Insufficient funds', action: 'retry_or_new_card' },
    '54': { message: 'Expired card', action: 'check_card' },
    '55': { message: 'Incorrect PIN', action: 'retry' },
    '57': { message: 'Transaction not permitted for this card', action: 'contact_bank'},
    '61': { message: 'Amount limit exceeded', action: 'retry_lower_amount' },
    '62': { message: 'Restricted card', action: 'contact_bank' },
    '65': { message: 'Transaction limit exceeded', action: 'wait_or_contact_bank',},
    '75': { message: 'Too many PIN attempts', action: 'wait_or_contact_bank' },
    '91': { message: 'Bank unavailable', action: 'retry_later' },
    '96': { message: 'System error', action: 'retry_later' },
  };

  // Método para evaluar la respuesta
  evaluatePaymentResponse(apiResponse: IResponseObjectSuccess<PaymentResponseData>): PaymentResult {
    const response = apiResponse?.data?.response || {};
    const issuerCode =
      response.IssuerResponseCode ||
      (response.responseCode !== undefined ? response.responseCode.toString().padStart(2, '0') : '00');
    const codeData = this.responseCodes[issuerCode] || {
      message: response.authMessage || 'Error desconocido',
      action: 'contact_support',
    };

    return {
      success: response.status === 'Approved',
      status:
        response.status?.toLowerCase() === 'approved' ? 'approved' : 'declined',
      message: codeData.message,
      code: issuerCode,
      action: codeData.action,
    };
  }
}

